import React, { useEffect, useState } from 'react';
import IconWallet from 'assets/img/icons/wallet.svg';
import { useDispatch, useSelector } from 'react-redux';
import { HIT_DETAIL_COMPANY } from 'redux/actions/company';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import IconEdit from 'assets/img/icons/edit-icon.svg';
import Button from 'components/_parts/atoms/button';
import styled from 'styled-components';
import FormEditCompany from 'components/company/revamp/parts/detailCompany/form';
import Label from 'components/_parts/atoms/label';
import { Formik } from 'formik';
import axios from 'axios';
import CompanyPlaceholder from 'assets/img/company_placeholder.png';
import { useTranslation } from 'react-i18next';
import {
  useCompanyFeedback,
  useDetailCompanyQuery,
  useUpdateCompanyMutation,
} from 'components/company/hooks/useCompany';
import validationSchema from './parts/detailCompany/validationSchema';
import initialValues from './parts/detailCompany/initialValues';

const BtnMod = styled(Button)`
  width: 34px;
  height: 24px;
`;

const EditPhotoCompany = styled(Button)`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 0px;
  right: 15px;
  cursor: pointer;
`;

const DivTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  column-gap: 20px;
`;

const IconEditNoBg = styled.img`
  background-color: #3d5afe;
  -webkit-mask: url(${IconEdit}) no-repeat center;
  mask: url(${IconEdit}) no-repeat center;
  width: 20px;
  height: 20px;
  cursor: pointer;
`;

const BtnSave = styled(Button)`
  width: 92px;
  height: 40px;
`;

function ContentLeft() {
  const { t } = useTranslation();
  const [editMode, setEditMode] = useState(false);
  const [tempPict, setTempPict] = useState<File | undefined>(undefined);
  const [pict, setPict] = useState<string | undefined>(undefined);
  const feedback = useCompanyFeedback();
  const updateCompanyMutation = useUpdateCompanyMutation();
  useDetailCompanyQuery({
    company_id: '008689ae-a3ad-11e9-8f66-b42e992b9a51',
  });
  const { detail } = useSelector((state: any) => ({
    detail: state?.company?.detail,
  }));

  const [data, setData] = useState(initialValues);
  useEffect(() => {
    setData({
      name: detail?.name,
      description: detail?.description,
    });
    setPict(detail?.logo);
  }, [detail]);
  return (
    <>
      <DivTitle>
        <h2 className="new_company_settings_container-left_side-title text-center">
          {t('company.about_company')}
        </h2>
        {!editMode && (
          <span>
            <BtnMod func={() => setEditMode(!editMode)}>
              <img src={IconEdit} alt="edit-company" />
            </BtnMod>
          </span>
        )}
      </DivTitle>
      <div className="new_company_settings_container-left_side-content text-center mx-auto">
        <Formik
          initialValues={data}
          validationSchema={validationSchema({ t })}
          enableReinitialize
          onSubmit={async (values, { resetForm }) => {
            feedback.setLoading(true);
            try {
              const formData = new FormData();
              let tempImg = '';
              let tempFile = '';
              if (tempPict !== undefined) {
                const allowedTypes = ['jpg', 'jpeg', 'png', 'jfif'];
                const checkTypes = tempPict.name.split('.').pop().toLowerCase();
                if (allowedTypes.includes(checkTypes) === false) {
                  feedback.setStatus(
                    'failed',
                    'File extensi yang dibolehkan hanya png, jpg, jpeg, jfif',
                  );
                  feedback.setLoading(false);
                  setTempPict(undefined);
                  return;
                }

                formData.append('file', tempPict);
                formData.append('type', 'company_logo');
                const uploadImg = await axios
                  .post(`${process.env.REACT_APP_API}cdn/upload`, formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      Authorization: localStorage.getItem('token'),
                    },
                  })
                  .catch((error) => {
                    feedback.setStatus('failed', error.response.data.message);
                    return undefined;
                  });
                tempImg = uploadImg.data.data.directory;
              }
              const formData2 = new FormData();
              if (values.file) {
                const allowedTypes = ['pdf', 'png', 'jpg', 'jpeg', 'jfif'];
                const existTypes = values.file.name
                  .split('.')
                  .pop()
                  .toLowerCase();
                if (allowedTypes.includes(existTypes) === false) {
                  feedback.setStatus(
                    'failed',
                    'File extensi yang dibolehkan hanya pdf, png, jpg, jpeg, jfif',
                  );
                  feedback.setLoading(false);
                  return;
                }

                formData2.append('file', values.file);
                formData2.append('type', 'wla_guideline_doc');
                const uploadImg = await axios
                  .post(`${process.env.REACT_APP_API}cdn/upload`, formData2, {
                    headers: {
                      'Content-Type': 'multipart/form-data',
                      Authorization: localStorage.getItem('token'),
                    },
                  })
                  .catch((error) => {
                    feedback.setStatus('failed', error.response.data.message);
                    return undefined;
                  });
                tempFile = uploadImg.data.data.directory;
              }

              let payload = { ...values };

              if (tempImg !== '') {
                payload = { ...payload, logo: tempImg };
              }

              if (tempFile !== '') {
                payload = { ...payload, wla_guideline_doc: tempFile };
              }

              delete payload.description_show;

              if (
                values.name !== detail.name
                || values.description !== detail.description
                || tempFile !== ''
                || tempImg !== ''
              ) {
                await updateCompanyMutation.mutateAsync({
                  ...payload,
                });
                localStorage.setItem('company_name', values.name);
                if (tempImg !== '') {
                  localStorage.setItem('pictCompany', tempImg);
                }
              }
            } catch (error) {
              feedback.setStatus('failed', error instanceof Error ? error.message : String(error));
              feedback.setLoading(false);
            }
            setTimeout(() => {
              feedback.setLoading(false);
            }, 400);
            resetForm();
            setEditMode(!editMode);
          }}
        >
          {({ handleSubmit, setFieldValue }) => (
            <>
              <div className="company_photo position-relative">
                <img
                  // src={process.env.REACT_APP_CDN + detail?.logo}
                  src={
                    pict !== undefined
                      ? tempPict !== undefined
                        ? URL.createObjectURL(tempPict)
                        : process.env.REACT_APP_CDN + pict
                      : CompanyPlaceholder
                  }
                  style={{ width: 'inherit', height: '100%', borderRadius: '50%' }}
                  alt=""
                />
                {editMode && (
                  <EditPhotoCompany>
                    <label
                      htmlFor="image-input"
                      style={{ cursor: 'pointer' }}
                    >
                      <img
                        src={IconEdit}
                        alt="edit-company"
                        width={20}
                        height={20}
                      />
                      <input
                        className="d-none"
                        id="image-input"
                        type="file"
                        accept=".jpg, .jpeg, .png, .jfif, .JPG, .JPEG, .PNG, .JFIF"
                        onChange={(e) => setTempPict(e.target.files[0])}
                      />
                    </label>
                  </EditPhotoCompany>
                )}
              </div>
              {editMode ? (
                <>
                  {/* form edit */}
                  <FormEditCompany t={t} />
                  {/* form edit */}
                </>
              ) : (
                <>
                  <div>
                    <h3 className="company_name">{detail?.name}</h3>
                  </div>
                  <div className="company_guideline">
                    <img src={IconWallet} alt="icon-guideline" />
                    <Link
                      to={{
                        pathname: `${process.env.REACT_APP_CDN
                          + detail?.wla_guideline_doc
                        }`,
                      }}
                      target="_blank"
                      relative="path"
                      rel="noreferrer"
                    >
                      <span>
                        {t('company.guidline')}
                        {' '}
                        A.1
                      </span>
                    </Link>
                  </div>
                </>
              )}

              <div id="textDetailJobdesc" className="company_desc">
                {!editMode ? (
                  <p
                    id="textDetailJobdesc"
                    className="descCompany"
                    dangerouslySetInnerHTML={{
                      __html: detail?.description || '-',
                    }}
                  />
                ) : (
                  <>
                    {' '}
                    <div
                      className="d-flex flex-column"
                      style={{
                        marginTop: '13px',
                        rowGap: '5px',
                        alignItems: 'center',
                      }}
                    >
                      <Label className="label_md">{t('company.update_guidline')}</Label>
                      <div className="d-flex flex-row justify-content-center align-items-center company_guideline">
                        <img
                          src={IconWallet}
                          height={16}
                          alt="icon-guideline"
                        />
                        <Link
                          to={{
                            pathname: `${process.env.REACT_APP_CDN
                              + detail?.wla_guideline_doc
                            }`,
                          }}
                          target="_blank"
                          relative="path"
                          rel="noreferrer"
                        >
                          <span>
                            {t('company.guidline')}
                            {' '}
                            A.1
                          </span>
                        </Link>
                        <label htmlFor="file_guideline">
                          <IconEditNoBg />
                        </label>
                        <input
                          className="form-control d-none"
                          type="file"
                          hidden
                          accept=".jpg, .jpeg, .png, .jfif, .pdf, .JPG, .JPEG, .PNG, .JFIF, .PDF"
                          name="wla_guideline_doc"
                          id="file_guideline"
                          onChange={(event) => {
                            setFieldValue(
                              'file',
                              event.currentTarget.files[0],
                            );
                          }}
                        />
                      </div>
                      <BtnSave
                        func={() => {
                          handleSubmit();
                        }}
                      >
                        {t('workload_landing.save')}
                      </BtnSave>
                    </div>
                  </>
                )}
                <div className="company_desc-created">
                  <div>
                    <span>{t('org.employee.created_at')}</span>
                  </div>
                  <div>{dayjs(detail?.created_at).format('D MMM YYYY')}</div>
                  <div>
                    <span>{t('company.company_admin')}</span>
                  </div>
                  <div>-</div>
                </div>
              </div>
            </>
          )}
        </Formik>
      </div>
    </>
  );
}

export default ContentLeft;
